import { apiHelper } from '@/utils'
import { API } from '@/constants'

const API_URL = API.BASE_URL + '/v1'

export const leadActivityService = {
  getAll,
  create,
  update,
  remove,
  complete,
  getToday,
  getOverdue,
  getUpcoming,
  getCalendar,
}

export function getAll(filter = {}) {
  const params = {}
  if (filter.debtorCode) params.debtor_code = filter.debtorCode
  if (filter.leadableType) params.leadable_type = filter.leadableType
  if (filter.leadableId) params.leadable_id = filter.leadableId
  if (filter.type) params.type = filter.type
  if (filter.status) params.status = filter.status
  if (filter.assignedTo) params.assigned_to = filter.assignedTo
  if (filter.pinnedOnly) params.pinned_only = true
  if (filter.size) params.size = filter.size
  return apiHelper(API_URL).get('/lead-activities', { params })
}

export function create(payload) {
  return apiHelper(API_URL).post('/lead-activities', payload)
}

export function update(uuid, payload) {
  return apiHelper(API_URL).put(`/lead-activities/${uuid}`, payload)
}

export function remove(uuid) {
  return apiHelper(API_URL).delete(`/lead-activities/${uuid}`)
}

export function complete(uuid) {
  return apiHelper(API_URL).patch(`/lead-activities/${uuid}/complete`)
}

export function getToday() {
  return apiHelper(API_URL).get('/activities/today')
}

export function getOverdue() {
  return apiHelper(API_URL).get('/activities/overdue')
}

export function getUpcoming() {
  return apiHelper(API_URL).get('/activities/upcoming')
}

export function getCalendar(dateFrom, dateTo) {
  return apiHelper(API_URL).get('/activities/calendar', { params: { date_from: dateFrom, date_to: dateTo } })
}
